import {
    useEffect,
    useState,
} from "react";

import CrudModal from "components/crud/CrudModal";
import CrudInput from "components/crud/CrudInput";
import CrudSelect from "components/crud/CrudSelect";

import {
    createBook,
    updateBook,
} from "services/api/bookApi";

import {
    showSuccess,
    showError,
} from "utils/toast";


const DEFAULT_FORM = {

    bookCode: "",
    title: "",
    isbn: "",
    publisher: "",
    className: "",
    subject: "",
    language: "",
    status: "active",

};


export default function BookModal({
    open,
    onClose,
    reload,
    item,
}) {

    const isEdit =
        Boolean(item);


    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        form,
        setForm,
    ] = useState(
        DEFAULT_FORM
    );


    // =========================================================
    // INITIALIZE
    // =========================================================

    useEffect(
        () => {

            if (!open) {
                return;
            }


            if (item) {

                setForm({

                    bookCode:
                        item.bookCode ||
                        "",

                    title:
                        item.title ||
                        "",

                    isbn:
                        item.isbn ||
                        "",

                    publisher:
                        item.publisher ||
                        "",

                    className:
                        item.className ||
                        "",

                    subject:
                        item.subject ||
                        "",

                    language:
                        item.language ||
                        "",

                    status:
                        item.status ||
                        "active",

                });

            } else {

                setForm({
                    ...DEFAULT_FORM,
                });

            }

        },
        [
            open,
            item,
        ]
    );


    // =========================================================
    // CHANGE
    // =========================================================

    const handleChange =
        (e) => {

            const {
                name,
                value,
            } = e.target;


            setForm(
                (prev) => ({
                    ...prev,
                    [name]:
                        value,
                })
            );
        };


    // =========================================================
    // VALIDATION
    // =========================================================

    const validate =
        () => {

            if (
                !form.title.trim()
            ) {

                showError(
                    "Book title is required."
                );

                return false;

            }


            return true;
        };


    // =========================================================
    // SUBMIT
    // =========================================================

    const handleSubmit =
        async (e) => {

            e.preventDefault();


            if (
                !validate()
            ) {
                return;
            }


            try {

                setLoading(
                    true
                );


                const payload = {

                    bookCode:
                        form.bookCode.trim() ||
                        undefined,

                    title:
                        form.title.trim(),

                    isbn:
                        form.isbn.trim() ||
                        undefined,

                    publisher:
                        form.publisher.trim() ||
                        undefined,

                    className:
                        form.className.trim() ||
                        undefined,

                    subject:
                        form.subject.trim() ||
                        undefined,

                    language:
                        form.language.trim() ||
                        undefined,

                    status:
                        form.status,

                };


                if (isEdit) {

                    await updateBook(
                        item.id,
                        payload
                    );


                    showSuccess(
                        "Book updated successfully."
                    );

                } else {

                    await createBook(
                        payload
                    );


                    showSuccess(
                        "Book created successfully."
                    );

                }


                await reload();

                onClose();

            } catch (
                error
            ) {

                console.error(
                    "Book save error:",
                    error
                );


                showError(
                    error?.response?.data?.message ||
                    "Unable to save book."
                );

            } finally {

                setLoading(
                    false
                );

            }

        };


    if (!open) {
        return null;
    }


    return (

        <CrudModal

            open={
                open
            }

            title={
                isEdit
                    ? "Edit Book"
                    : "Add Book"
            }

            loading={
                loading
            }

            submitText={
                isEdit
                    ? "Update"
                    : "Save"
            }

            onClose={
                onClose
            }

            onSubmit={
                handleSubmit
            }

            width="max-w-5xl"

        >

            <div
                className="
                    grid
                    grid-cols-1
                    gap-5
                    md:grid-cols-2
                "
            >

                <CrudInput
                    label="Book Code"
                    name="bookCode"
                    value={
                        form.bookCode
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="BK001"
                />


                <CrudInput
                    label="Book Title"
                    name="title"
                    value={
                        form.title
                    }
                    onChange={
                        handleChange
                    }
                    required
                    placeholder="Mathematics Class 5"
                />


                <CrudInput
                    label="ISBN"
                    name="isbn"
                    value={
                        form.isbn
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="9781234567890"
                />


                <CrudInput
                    label="Publisher"
                    name="publisher"
                    value={
                        form.publisher
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="Oswal Publishers"
                />


                <CrudInput
                    label="Class"
                    name="className"
                    value={
                        form.className
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="Class 5"
                />


                <CrudInput
                    label="Subject"
                    name="subject"
                    value={
                        form.subject
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="Mathematics"
                />


                <CrudInput
                    label="Language"
                    name="language"
                    value={
                        form.language
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="English"
                />


                <CrudSelect
                    label="Status"
                    name="status"
                    value={
                        form.status
                    }
                    onChange={
                        handleChange
                    }
                    options={[
                        {
                            value: "active",
                            label: "Active",
                        },
                        {
                            value: "inactive",
                            label: "Inactive",
                        },
                    ]}
                />

            </div>

        </CrudModal>
    );
}